import { ActivityIndicator, Pressable, StyleSheet, Text, View } from 'react-native';
import { AlertTriangle } from 'lucide-react-native';
import { theme } from '@/constants/theme';

type RuntimeAsyncStateProps = {
  state: 'loading' | 'empty' | 'error' | 'degraded';
  title: string;
  description: string;
  retryLabel?: string;
  onRetry?: () => void;
  actionLabel?: string;
  onAction?: () => void;
};

const BG = '#0B0B14';
const TEXT = '#F0EFF8';
const TEXT_MED = '#B3B2CD';
const BORDER = '#2D2B50';
const PRIMARY = theme.colors.primary;

export function RuntimeAsyncState({
  state,
  title,
  description,
  retryLabel = 'נסה שוב',
  onRetry,
  actionLabel,
  onAction,
}: RuntimeAsyncStateProps) {
  return (
    <View style={s.wrap}>
      {state === 'loading' ? (
        <ActivityIndicator color={PRIMARY} size="large" />
      ) : (
        <View style={s.iconWrap}>
          <AlertTriangle color="#F59E0B" size={24} />
        </View>
      )}
      <Text style={s.title}>{title}</Text>
      <Text style={s.description}>{description}</Text>
      {onRetry && state !== 'loading' && (
        <Pressable style={({ pressed }) => [s.primaryBtn, pressed && s.btnPressed]} onPress={onRetry}>
          <Text style={s.primaryText}>{retryLabel}</Text>
        </Pressable>
      )}
      {actionLabel && onAction && (
        <Pressable style={({ pressed }) => [s.secondaryBtn, pressed && s.btnPressed]} onPress={onAction}>
          <Text style={s.secondaryText}>{actionLabel}</Text>
        </Pressable>
      )}
    </View>
  );
}

const s = StyleSheet.create({
  wrap: {
    flex: 1,
    backgroundColor: BG,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    gap: 10,
  },
  iconWrap: {
    width: 44,
    height: 44,
    borderRadius: 999,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: BORDER,
    backgroundColor: '#1A172A',
  },
  title: { color: TEXT, fontFamily: theme.fonts.bold, textAlign: 'center', fontSize: 20 },
  description: { color: TEXT_MED, fontFamily: theme.fonts.regular, textAlign: 'center', fontSize: 16, lineHeight: 22, maxWidth: 420 },
  primaryBtn: { backgroundColor: PRIMARY, borderRadius: 10, minHeight: 44, paddingVertical: 10, paddingHorizontal: 18, marginTop: 6, justifyContent: 'center' },
  primaryText: { color: '#fff', fontFamily: theme.fonts.bold, fontSize: 16 },
  secondaryBtn: { borderWidth: 1, borderColor: BORDER, borderRadius: 10, minHeight: 44, paddingVertical: 10, paddingHorizontal: 18, justifyContent: 'center' },
  secondaryText: { color: TEXT_MED, fontFamily: theme.fonts.medium, fontSize: 16 },
  btnPressed: { opacity: 0.9 },
});
